import layout from './InitialConfigView.html?raw';
import ComponentManager from '@/Management/ComponentManager';
import TwoFactorInitialConfigViewModel from '@/Components/TwoFaktorAuth/InitialConfig/TwoFactorInitialConfigViewModel';
import View from '@/Views/View';
import Utilities from '@/Utility/Utilities';
import QRCodeHelper from '@/Components/TwoFaktorAuth/QRCodeHelper';

export default class TwoFactorInitialConfigView extends View {
    private view: JQuery<HTMLElement>;

    public constructor(public viewModel: TwoFactorInitialConfigViewModel, private element?: JQuery) {
        super();

        this.defineSubscription(this.viewModel.token, (token) => {
            if (!Utilities.isNullOrUndefinedOrBlank(token))
                QRCodeHelper.createQRCodeOnElement($('.qr-code'), token);
            else
                QRCodeHelper.cleanUpArea($('.qr-code'));
        });
    }

    public getView(): JQuery<HTMLElement> {
        if (this.view != null) {
            return this.view;
        }

        this.view = this.applyBindings(this.element, this.viewModel, layout);

        return this.view;
    }
}

ComponentManager.setView('TwoFactorInitialConfigView', TwoFactorInitialConfigView, 'RADPresentation.HTMLClient.DefaultViewExtensions');